import { G_API } from "../constants/globalVar";
import { Link } from "react-router-dom";

const SelectedArticles = ({ item }) => {
    const defaultImage = G_API + 'uploads/ahnyar-logo.png';
    const imageUrl = item?.feature_img?.src ? item.feature_img.src : defaultImage;

    const data = {
        image: imageUrl,
        title: item.title,
        description: item.description ?? '....',
        updated_at: item.updated_at,
        url: item.is_department ? `/departments-articles/${item.id}` : `/blogs/${item.id}`,
    };

    return (
        <div>
            <div className="card mb-4">
                <div className="card-header p-0">
                    <img src={data.image ?? defaultImage } className="img-fluid rounded-start" alt={data.title}
                        style={{
                            objectFit: 'cover',
                            height: '250px',
                            maxHeight: '250px',
                            width: '100%',
                            overflow: 'hidden'
                        }}
                    />
                </div>
                <div className="card-body text-center">
                    <div className="card-body flex-grow-1">
                        <h5 className="card-title">{data.title}</h5>
                        <p className="card-text" style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: '2.5',
                            minHeight: '7.5em',
                        }}><span dangerouslySetInnerHTML={{ __html: data.description }} /></p>
                        <Link className="btn btn-outline-warning" to={data.url} target="_blank" rel="noopener noreferrer">
                            View Detail
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SelectedArticles;
